"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _modalUtils = require("../utils/modalUtils");
var _Icon = _interopRequireDefault(require("../Icon"));
var _messages = require("./messages");
var _getLanguage = _interopRequireDefault(require("../utils/getLanguage"));
var _TabbingTrapper = _interopRequireDefault(require("../TabbingTrapper"));
var _SlidePanel_css = _interopRequireDefault(require("./SlidePanel_css"));
// Breaks IE 11 for some reason...

// Let's create a Modal component that is an abstraction around
// the portal API.
class SlidePanel extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _appendCss.default)("arc_slidepanel", _SlidePanel_css.default);
    this.language = (0, _getLanguage.default)();

    // get the element the panel will be injected into
    this.modalRoot = (0, _modalUtils.getModalRoot)();

    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.el = document.createElement("div");
    this.applyWrapper = this.applyWrapper.bind(this);
    this.close = this.closePanel.bind(this);
    this.handlePanelClick = this.handlePanelClick.bind(this);
    this.state = {
      isClosing: false,
      baseIsMounted: false
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !this.state.baseIsMounted) {
      this.modalRoot.appendChild(this.el);
      this.setState({
        baseIsMounted: true
      });
    }
  }
  componentWillUnmount() {
    // Remove the element from the DOM when we unmount
    if (this.state.baseIsMounted) this.modalRoot.removeChild(this.el);
  }
  applyWrapper() {
    if (!this.state.baseIsMounted) {
      return null;
    }
    const overlayClasses = (0, _classnames.default)({
      "PanelContainer--overlay": true,
      "closing": this.state.isClosing
    });
    const panelClasses = (0, _classnames.default)({
      "PanelContainer--panel": true,
      [this.props.alignment + "-edge"]: true,
      "no-padding": !this.props.defaultPadding,
      "closing": this.state.isClosing
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `PanelContainer ${this.props.variant}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: overlayClasses,
      onClick: this.close
    }), /*#__PURE__*/_react.default.createElement(_TabbingTrapper.default, {
      escCallback: this.close,
      focusElement: this.props.focusOnOpen
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: panelClasses,
      onClick: this.handlePanelClick,
      role: "dialog",
      "aria-modal": "true"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "PanelContainer--content"
    }, this.props.children), !this.props.hideCloseIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "button",
      title: _messages.messages[this.language].close,
      icon: "close",
      className: "PanelContainer--close-icon",
      onClick: this.close
    }))));
  }
  handlePanelClick(evt) {
    if (this.props.closeOnClick) {
      this.close(evt);
    }
  }
  closePanel(evt) {
    if (this.props.onClose !== null) {
      let self = this;
      this.setState({
        isClosing: true
      });
      setTimeout(() => {
        self.setState({
          isClosing: false
        });
        self.props.onClose(evt);
        (0, _modalUtils.handleFocusElement)(self.props.focusOnClose);
      }, 250);
    }
  }
  render() {
    // Use a portal to render the children into the element
    if (!this.props.isOpen) return null;
    return /*#__PURE__*/_reactDom.default.createPortal(
    // Any valid React child: JSX, strings, arrays, etc.
    this.applyWrapper(), this.el); // A DOM element
  }
}
exports.default = SlidePanel;
SlidePanel.propTypes = {
  /** Which edge of the screen to anchor SlidePanel. One of ["left", "right"] */
  alignment: _propTypes.default.oneOf(["left", "right"]),
  /** Boolean to tell the panel to close when the user clicks within the panel. */
  closeOnClick: _propTypes.default.bool,
  /** Show/Hide the panel */
  isOpen: _propTypes.default.bool,
  /** Function to call onClose of panel */
  onClose: _propTypes.default.func,
  /** Boolean to hide the X icon. */
  hideCloseIcon: _propTypes.default.bool,
  /** Boolean to apply (or not) some padding to panel container. */
  defaultPadding: _propTypes.default.bool,
  /** A css class name added to this instance of the panel */
  variant: _propTypes.default.string,
  /** CSS query selector value for the element that should recieve initial focus */
  focusOnOpen: _propTypes.default.string,
  /** react REF object for the focusable element that should be refocused when the modal closes */
  focusOnClose: _propTypes.default.object
};
SlidePanel.defaultProps = {
  alignment: "right",
  closeOnClick: false,
  isOpen: false,
  onClose: null,
  hideCloseIcon: false,
  defaultPadding: true,
  variant: "",
  focusOnOpen: null,
  focusOnClose: null
};